import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TableBasicClick } from 'components';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useUsers, useEditUser, useAddUser, useDeleteUser, useUserLogs } from 'hooks/users.hook';
import * as Icon from 'react-bootstrap-icons';
import Multiselect from 'multiselect-react-dropdown';
import { date, dateTime, convertDecimalToIntCoord } from 'helpers/formatter';
import { useGeolocation } from 'hooks/geolocation.hook';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { MarkerWithInfoWindow } from 'components/MarkerWithInfoWindow';

export { Users };

function Users() {
  const [validated, setValidated] = useState(false);
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [passwordMatchValidation, setPasswordMatchValidation] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedUserId, setSelectedUserId] = useState('00000000-0000-0000-0000-000000000000');
  const [selectedRoles, setSelectedRoles]= useState([{}]);
  const [showMapDialog, setShowMapDialog] = useState(false);

  const authUser = useSelector(x => x.auth.user);
  
  const roles = [
    {"name": "Administrator", "id": 1 },
    {"name": "Standard", "id": 2 },
    {"name": "Accounts", "id": 100 },
    {"name": "Budget", "id": 200 },
    {"name": "Wallet", "id": 300 },
    {"name": "Boards", "id": 400 },
    {"name": "Network", "id": 500 },
    {"name": "Vaults", "id": 600 },
    {"name": "Inventory", "id": 700 },
    {"name": "News", "id": 800 },
    {"name": "Location", "id": 900 },
    {"name": "Weather", "id": 1000 }
  ];

  const { data: userLogsData } = useUserLogs(selectedUserId);
  const [userLogs, setUserLogs] = useState([]);
  useEffect(() => { 
    if (userLogsData !== undefined && selectedUser !== undefined) {
          setUserLogs(userLogsData); 
    }
  }, [userLogsData, selectedUser]);

  const { data: usersData, error: usersError, isError: usersIsError, isLoading: usersIsLoading } = useUsers();
  const [users, setUsers] = useState([]);
  useEffect(() => { 
    if (usersData !== undefined) {
          setUsers(usersData); 
    }
  }, [usersData]);

  const addUserMutation = useAddUser();
  const editUserMutation = useEditUser();
  const deleteUserMutation = useDeleteUser();

  const handleAddClose = () => setShowAddDialog(false);
  const handleEditClose = () => setShowEditDialog(false);
  const handleDeleteClose = () => setShowDeleteDialog(false);

  /*
  useEffect(() => {
    if (addUserMutation && addUserMutation.isSuccess) {
      //setShowAddDialog(false);
      //setValidated(false);
    }
  }, [addUserMutation]);
*/

  const handleDelete = () => {
    deleteUserMutation.mutate({
      id: selectedUser.id,
    });
    setShowDeleteDialog(false);
    setShowEditDialog(false);
  };

  const handleAddSubmit = (event) => {
    setPasswordMatchValidation(true);
    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      let memebershipExpire = form.formMembershipExpire.value;
      if (memebershipExpire === '') { memebershipExpire = null; }

      if (form.formPassword1.value === form.formPassword2.value) {
        addUserMutation.mutate({
          firstName: form.formFirstName.value,
          lastName: form.formLastName.value,
          username: form.formUsername.value,
          password: form.formPassword1.value,
          membershipExpire: memebershipExpire,
          rolesJson: JSON.stringify(selectedRoles)
        });

        setShowAddDialog(false);
        setValidated(false);
      }
      else {
        setPasswordMatchValidation(false);
        setValidated(true);
      }
    }
    else {
      setValidated(true);
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const handleEditSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      let memebershipExpire = form.formMembershipExpire.value;
      if (memebershipExpire === '') { memebershipExpire = null; }

      if (form.formPassword1.value === form.formPassword2.value) {
        editUserMutation.mutate({
          id: selectedUser.id,
          firstName: form.formFirstName.value,
          lastName: form.formLastName.value,
          username: form.formUsername.value,
          password: form.formPassword1.value,
          membershipExpire: memebershipExpire,
          isActive: isActive,
          rolesJson: JSON.stringify(selectedRoles)
        });

        setShowEditDialog(false);
        setValidated(false);
      }
      else {
        setPasswordMatchValidation(false);
        setValidated(true);
      }
    }
    else {
      setValidated(true);
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const editOnClick = (account) => {
    if (account != null) {
      setSelectedUser(account);
      setSelectedUserId(account.id);
      setSelectedRoles(account.roles.map(item => { return {"id":item.roleId, "name":""}; }));
      setIsActive(account.isActive);
      setShowEditDialog(true);
      setPasswordMatchValidation(true);
    }
  };

  const handlerRoleOnSelect = (selectedList, selectedItem) => {
    let selectedIds = selectedList.map(item => { return {"id":item.id, "name":""}; });
    setSelectedRoles(selectedIds);
  }

  const { currentCoords, isGeoOn} = useGeolocation();
  
  const viewUserLogsClick = (isCurrent) => {
    if (isGeoOn) {
      //userLogs.push({id:'0', name:'You are here!', latitude:convertDecimalToIntCoord(currentCoords.lat), longitude:convertDecimalToIntCoord(currentCoords.lng), location:' ', dateStart:new Date().toLocaleDateString(), dateEnd:new Date().toLocaleDateString(), price:'0' });
    }

    if (isCurrent && users !== undefined) {
      let current = ({id: authUser.id, username: authUser.username, firstName: authUser.firstName, lastName: authUser.lastName });
      setSelectedUser(current);
      setSelectedUserId(current.id);
    }

    setShowMapDialog(true);
  }

  const formatTrProps = (state = {}) => {
    return { onClick: () => editOnClick(state.original) };
  };
  const columns = useMemo(
    () => [
      {
        Header: "Username",
        accessor: "username",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Is Active",
        accessor: "isActive",
        Cell: ({ row }) => (
          <>
            {row.original.isActive && (<div><Icon.Check size={25} /></div>)}
          </>
        )
      },
      {
        Header: "Roles",
        accessor: "id",
        Cell: ({ row }) => (
          <>
            {row.original.roles && row.original.roles.sort((a, b) => a.roleId > b.roleId ? 1 : -1).map(e => <div key={e.roleId}>{roles.filter(m => m.id === e.roleId).map(f =>f.name)}</div>)}
          </>
        )
      },
      {
        Header: "Last Logged In",
        accessor: "LastLoggedIn",
        Cell: ({ row }) => (
          <>
            {row.original.lastLoggedIn && dateTime(new Date(row.original.lastLoggedIn).setHours(new Date(row.original.lastLoggedIn).getHours() - 4))}
          </>
        )
      },
      {
        Header: "Membership Expire",
        accessor: "membershipExpire",
        Cell: ({ row }) => (
          <>                
            {row.original.membershipExpire && <span className={new Date(row.original.membershipExpire) < new Date() ? "inventory-danger" : ""}>{date(row.original.membershipExpire)}</span>}
          </>
        )
      },
    ],
    []
  );

  return (
    <div className='panel'>
      <h1><Icon.PeopleFill size={35} /> Users</h1>
      <p></p>
      <hr></hr>
      <p>
        <button className='btn btn-primary' onClick={() => setShowAddDialog(true)} ><Icon.Plus size={20} /> Add User</button>&nbsp;
        {users && <button className='btn btn-secondary' onClick={() => viewUserLogsClick(true)} ><Icon.Person size={20} /> User Logs</button>}
      </p>

      {users && <TableBasicClick responsive columns={columns} data={users} formatRowProps={(state) => formatTrProps(state)} />}
      {usersIsLoading && <div className='text-center'><div className="spinner-border spinner-border-lg"></div></div>}
      {usersIsError && <div className="text-danger">Error loading users: {usersError.message}</div>}

      <Modal
        size="lg"
        show={showAddDialog}
        onHide={() => setShowAddDialog(false)}
        aria-labelledby="modal-add-account"
      >
        <Form noValidate validated={validated} onSubmit={handleAddSubmit}>
          <Modal.Header closeButton closeVariant='white'>
            <Modal.Title id="modal-add-account">Add User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control required maxLength="50" type="text" placeholder="Enter a username" />
              <Form.Control.Feedback type="invalid">Please enter a username.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formRoles">
              <Form.Label>Roles</Form.Label>
              <Multiselect
                displayValue="name"
                placeholder="Must include at least 1 role"
                onKeyPressFn={function noRefCheck() { }}
                onRemove={handlerRoleOnSelect}
                onSearch={function noRefCheck() { }}
                onSelect={handlerRoleOnSelect}
                options={roles}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control required maxLength="50" type="text" placeholder="Enter a first name" />
              <Form.Control.Feedback type="invalid">Please enter a first name.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control required maxLength="50" type="text" placeholder="Enter a last name" />
              <Form.Control.Feedback type="invalid">Please enter a last name.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPassword1">
              <Form.Label>Password</Form.Label>
              <Form.Control required type="password" placeholder="Enter a password" />
              <Form.Control.Feedback type="invalid">Please enter a password.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPassword2">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control required type="password" placeholder="Confirm password" />
              <Form.Control.Feedback type="invalid">Please confirm password.</Form.Control.Feedback>
              {!passwordMatchValidation && <div className="form-error">Your password does not match. Please try again</div>}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formMembershipExpire">
                <Form.Label>Membership Expire</Form.Label>
                <Form.Control type="date" placeholder="Enter a membership expire date" />
            </Form.Group>
            {addUserMutation.isError && <div className="form-error"><p></p>{addUserMutation.error.response.data}</div>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">Save</Button>&nbsp;
            <Button variant="secondary" type="button" onClick={handleAddClose}>Cancel</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        size="lg"
        show={showEditDialog}
        onHide={() => setShowEditDialog(false)}
        aria-labelledby="modal-edit-account"
      >
        <Form noValidate validated={validated} onSubmit={handleEditSubmit}>
          <Modal.Header closeButton closeVariant='white'>
            <Modal.Title id="modal-edit-account">Edit User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <a className="btn-card-viewer" onClick={() => viewUserLogsClick(false)} href='#'><Icon.WindowFullscreen size={20} /></a>
            <Form.Group className="mb-3" controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control readOnly type="text" defaultValue={selectedUser.username} placeholder="Enter a username" />
              <Form.Control.Feedback type="invalid">Please enter a username.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formRoles">
              <Form.Label>Roles</Form.Label>
              <Multiselect
                displayValue="name"
                placeholder="Must include at least 1 role"
                onKeyPressFn={function noRefCheck() { }}
                onRemove={handlerRoleOnSelect}
                onSearch={function noRefCheck() { }}
                onSelect={handlerRoleOnSelect}
                selectedValues={selectedUser.roles && selectedUser.roles.map(item => { return { "name": roles.filter(r => r.id === item.roleId).map(n => n.name), "id": item.roleId } })}
                options={roles.filter(r => !selectedRoles.some(m => m.id === r.id))}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control required type="text" defaultValue={selectedUser.firstName} placeholder="Enter a first name" />
              <Form.Control.Feedback type="invalid">Please enter a first name.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control required type="text" defaultValue={selectedUser.lastName} placeholder="Enter a last name" />
              <Form.Control.Feedback type="invalid">Please enter a last name.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPassword1">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" placeholder="Enter a password" />
              <Form.Control.Feedback type="invalid">Please enter a password.</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPassword2">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control type="password" placeholder="Confirm password" />
              {!passwordMatchValidation && <div className="form-error">Your password does not match. Please try again</div>}
            </Form.Group>   
            <Form.Group className="mb-3" controlId="formMembershipExpire">
                <Form.Label>Membership Expire</Form.Label>
                <Form.Control type="date" defaultValue={selectedUser.membershipExpire && date(selectedUser.membershipExpire)} placeholder="Enter a membership expire date" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formIsActive">
              <Form.Label>Is Active</Form.Label>
              <Form.Check type="switch" defaultChecked={selectedUser.isActive} onChange={(e) => { setIsActive(!isActive); }} />
              <br />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">Save</Button>&nbsp;
            <Button variant="secondary" type="button" onClick={handleEditClose}>Cancel</Button>
            <Button variant="danger" className='modal-btn-right' onClick={() => setShowDeleteDialog(true)}>Delete</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        aria-labelledby="modal-delete"
      >
        <Modal.Header closeButton closeVariant='white'>
          <Modal.Title id="modal-delete">Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you would like to delete:</p>
          {showDeleteDialog && <div><p>{selectedUser.username}</p><p>{selectedUser.firstName}</p><p>{selectedUser.lastName}</p></div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" type="submit" onClick={handleDelete}>Yes</Button>&nbsp;
          <Button variant="secondary" type="button" onClick={handleDeleteClose}>No</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="xl"
        show={showMapDialog}
        onHide={() => setShowMapDialog(false)}
        aria-labelledby="modal-map"
      >
        <Modal.Header closeButton closeVariant='white'>
          <Modal.Title id="modal-map">User Log</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>{selectedUser.username}: {selectedUser.firstName} {selectedUser.lastName}</h4>
          {userLogs ?
            <div className='map-container'>
              <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={['marker']}>
                <Map
                  mapId={'bf51a910020fa25a'}
                  defaultZoom={10}
                  defaultCenter={currentCoords}
                  gestureHandling={'greedy'}
                  disableDefaultUI>
                  {userLogs.map(item => {
                    if (item.latitude === 0 && item.longitude === 0) { return ""; }
                    return <MarkerWithInfoWindow key={item.id} locations={userLogs} location={{ "type": "user", "id":`${item.id}`, "name": `${selectedUser.username}: ${selectedUser.firstName} ${selectedUser.lastName}`, "address": undefined, "latitude": item.latitude, "longitude": item.longitude }} />
                  })}
                </Map>
              </APIProvider>
            </div>
            : <></>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={() => setShowMapDialog(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}